import { SellerApiInsales } from 'components/sellers/SellerApiInsales/SellerApiInsales'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileApiInsales: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerApiInsales type='profile' sellerId={sellerId ?? ''} />
}
